import { validateApiResponse } from '../../../services';
import { listMembers } from '../../../services/membersService';
import { MEMBER_STATUS } from '../constants/copy';
import { ROLE_MEMBERS_PAGE_SIZE } from '../constants/roles';
import { useAsyncLoad } from './useAsyncLoad';
import { mapApiRoleMemberToUi } from './useRoleMembers';

const NO_MEMBERS = Object.freeze([]);

// TODO(CT-5563 / backend): only the first page is read; send the search to the server and page
// once the real endpoint exists (the mock holds fewer members than the page size).
const fetchMembers = () =>
  listMembers({ page_size: ROLE_MEMBERS_PAGE_SIZE }).then((res) =>
    validateApiResponse(res, 'Could not load the members')
      .body.items.filter((m) => m.status !== MEMBER_STATUS.REMOVED)
      .map(mapApiRoleMemberToUi),
  );

/** Assignable members (not removed) for the builder's Members step: `{ members, isLoading, error }`. */
export const useBuilderMembers = () => {
  const { data, isLoading, error } = useAsyncLoad(fetchMembers, NO_MEMBERS);
  return { members: data, isLoading, error };
};
